import type { CreateGameRoomOptions } from "@presidents/game-engine/src/game-room";
import React from "react";
import styled from "styled-components";
import { RuleLabels } from "./rule-labels";

const GameRulesList = styled.ul`
  list-style: none;
  margin: var(--spacing-default) 0;
  padding: 0;
`;
const GameRulesItem = styled.li`
  display: flex;
  align-items: center;
`;
const NewBadge = styled.span`
  margin-left: auto;
  font-size: 12px;
  display: inline-block;
  padding: 2px;
  background-color: var(--successMuted);
`;

export const hasEnabledRules = (
  rules: CreateGameRoomOptions["rules"],
  numGames: number
) => {
  const enabledRules = rules?.filter(
    (r) => r.enabled && r.fromGame <= numGames
  );
  return !!enabledRules && enabledRules.length > 0;
};

type Props = {
  numGames: number;
  rules: CreateGameRoomOptions["rules"];
};
const GameRules: React.FC<Props> = ({ numGames, rules }) => {
  const sortedRules = rules
    ?.filter((r) => r.enabled)
    .sort((a, z) => a.fromGame - z.fromGame);
  return (
    <GameRulesList>
      {sortedRules?.map((r) => {
        return (
          <GameRulesItem key={r.rule}>
            {r.fromGame <= numGames ? (
              <>
                ✅ {RuleLabels[r.rule]}
                {r.fromGame === numGames ? <NewBadge>New!</NewBadge> : null}
              </>
            ) : (
              <>🔒 ???</>
            )}
          </GameRulesItem>
        );
      })}
    </GameRulesList>
  );
};

export default GameRules;
